import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from '@env/index';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { DefaultLanguageCode, paths } from '@app/constants';
import { HttpService } from '@app/core/services/http';
import { Title, Meta } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { State } from '@app/core/features';
import { Globals } from '@app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  public checkChangeLanguage = new Subject<number>();

  constructor(
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private httpService: HttpService,
    private titleService: Title,
    private metaService: Meta,
    protected store: Store<State>,
    private globals: Globals
  ) { }

  public findMetaData(url = window.location.href) {
    this.translateService.get('META_DATA').subscribe(res => {
      const arrRouting = url.split('/');
      let routingName = '';
      nestedLoops: for (let index = arrRouting.length - 1; index >= 0; index--) {
        let subRoutingName = arrRouting[index];
        if (subRoutingName.includes('?')) {
          subRoutingName = subRoutingName.substring(0, subRoutingName.indexOf('?'));
        }
        if (subRoutingName === paths.DOWNLOAD_RAYCONNECT) {
          // This case for mobile
          routingName = paths.CHARTS_MANAGER;
          if (res['CHARTS_MANAGER'] !== undefined) {
            this.bindMetaData(res['CHARTS_MANAGER'], 'TITLE', res['TITLE_SUFFIX']);
            this.bindMetaData(res['CHARTS_MANAGER'], 'DESCRIPTION');
            break nestedLoops;
          }
        }
        else {
          // The other cases
          for (const propertyName in paths) {
            if (paths[propertyName] === subRoutingName && res[propertyName] !== undefined) {
              this.bindMetaData(res[propertyName], 'TITLE', res['TITLE_SUFFIX']);
              this.bindMetaData(res[propertyName], 'DESCRIPTION');
              routingName = subRoutingName;
              break nestedLoops;
            }
          }
        }
      }
      const resultArray = Object.keys(paths).map((personNamedIndex) => {
        const path = paths[personNamedIndex];
        return path;
      });

      const findDetail = resultArray.find(row => row === routingName);
      const findChartManager = arrRouting.find(row => row === paths.CHARTS_MANAGER);
      if (findChartManager || (
        routingName !== paths.LIST_BASED_SELECTOR
        && routingName !== paths.MAP_BASED_SELECTOR
        && routingName !== paths.FREE_CHART_SELECTOR
        && findDetail)) {
        this.globals.isDisplayProgressSpinner = false;
      }
    });
  }

  public bindMetaData(item, tagName: string, titleSuffix?: string) {
    if (item[tagName] !== undefined && item[tagName] !== '') {
      if (titleSuffix) {
        this.titleService.setTitle(item[tagName] + titleSuffix);
        this.metaService.updateTag({ name: tagName.toLowerCase(), content: item[tagName] + titleSuffix });
      }
      else {
        if (tagName.toUpperCase() === 'TITLE') {
          this.titleService.setTitle(item[tagName]);
        }
        this.metaService.updateTag({ name: tagName.toLowerCase(), content: item[tagName] });
      }

    } else {
      this.metaService.updateTag({ name: tagName.toLowerCase() });
    }
  }

  public getCountryCodeByCoordinate = (lat: number, lng: number): Observable<string> => {
    return this.httpService
      .get({
        url: `${environment.mapboxApi}${lng},${lat}.json?access_token=${environment.mapboxToken}`,
        baseUrl: ''
      })
      .pipe(
        mergeMap(this.handleGetCountryCodeByCoordinateResponse),
        catchError(err => {
          this.toastrService.error(err.error.Message);
          return throwError(err);
        })
      );
  }

  private handleGetCountryCodeByCoordinateResponse(response): Observable<string> {
    for (const item of response.features) {
      if (item.place_type[0] === 'country') {
        return item.properties.short_code === 'gb'
          ? of(DefaultLanguageCode)
            : ['fr', 'it', 'es', 'de', 'ca', 'au', 'dk', 'fi', 'nl', 'no', 'se', 'us', 'eu'].includes(item.properties.short_code)
              ? of(item.properties.short_code)
              : of(DefaultLanguageCode);
      }
    }
  }
}
